import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "new_client" }
const _hoisted_2 = { class: "identification_box" }
const _hoisted_3 = { class: "identification_list" }
const _hoisted_4 = { class: "active" }
const _hoisted_5 = { href: "#" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = { href: "#" }
const _hoisted_8 = { class: "form_box" }
const _hoisted_9 = { class: "field_wrapper" }
const _hoisted_10 = { class: "select_appeal" }
const _hoisted_11 = { class: "field_box" }
const _hoisted_12 = { class: "field form-group" }
const _hoisted_13 = { class: "field form-group" }
const _hoisted_14 = { class: "field form-group" }
const _hoisted_15 = { class: "field form-group" }
const _hoisted_16 = { class: "field form-group" }
const _hoisted_17 = { class: "field form-group" }
const _hoisted_18 = {
  for: "name_field",
  style: { marginBottom: '14px' }
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_select = _resolveComponent("ui-select")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_date_picker = _resolveComponent("ui-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("NewUser")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("PersonalInformation")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$localization.getTranslate("Identification")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$localization.getTranslate("Liveness")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
        class: "main_form",
        "data-toggle": "validator",
        role: "form",
        "data-lng": "ru"
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ui_select, {
              style: { minWidth: `400px` },
              items: _ctx.Appeals,
              modelValue: _ctx.appealModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appealModel) = $event)),
              onSelectedIndex: _ctx.onChangeAppeals,
              placeholder: _ctx.$localization.getTranslate('SelectAppeal')
            }, null, 8, ["items", "modelValue", "onSelectedIndex", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.FirstName,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.FirstName) = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeAppeals()))
                ],
                headerText: _ctx.$localization.getTranslate('Name'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.SecondName,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.SecondName) = $event)),
                  _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeAppeals()))
                ],
                headerText: _ctx.$localization.getTranslate('LastName'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.profile.Phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profile.Phone) = $event)),
                headerText: _ctx.$localization.getTranslate('Phone'),
                placeholder: "+371 22025333",
                readOnly: ""
              }, null, 8, ["modelValue", "headerText"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.profile.Email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profile.Email) = $event)),
                headerText: 'Email',
                placeholder: "doferson@gmail.com",
                type: "email",
                readOnly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.BirthPlace,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.BirthPlace) = $event)),
                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeAppeals()))
                ],
                headerText: _ctx.$localization.getTranslate('BirthPlace'),
                required: ""
              }, null, 8, ["modelValue", "headerText"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$localization.getTranslate("BirthDate")), 1),
              _createVNode(_component_ui_date_picker, {
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeAppeals())),
                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.BirthDate) = $event))
                ],
                style: { 'max-width': `280px` },
                modelValue: _ctx.BirthDate,
                dateFormat: "DD-MM-YYYY"
              }, null, 8, ["modelValue"]),
              _hoisted_19
            ])
          ])
        ]),
        (_ctx.ErrMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.ErrMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "ui_continue_button",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.GoNext && _ctx.GoNext(...args))),
          disabled: !_ctx.Validation()
        }, [
          _hoisted_22,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Continue")), 1)
        ], 8, _hoisted_21)
      ], 32)
    ])
  ]))
}